import {connect} from 'react-redux';
import ErrorList from './ErrorList.jsx';

const mapStateToProps = state => state.shared.error;

export default connect(mapStateToProps)(ErrorList);



// WEBPACK FOOTER //
// ./src/features/shared/error/ErrorListContainer.jsx